export default __webpack_public_path__ + "static/media/check.eb1a1e10.svg";